<button class="vc-btn vc-btn--large vc-btn--full vc-btn__facebook-connect" (click)="openFacebookConnect()">
  <span class="vc-btn__facebook-connect__icon">
    <img class="facebook__icon" src="/assets/svg/social-facebook-logo.svg" alt="" />
  </span>
  <span *ngIf="type == 'login'" class="vc-btn__facebook-connect__text" i18n="@@LOGIN_MODAL.FACEBOOK_BUTTON"
    >Log in with Facebook</span
  >
  <span *ngIf="type == 'register'" class="vc-btn__facebook-connect__text" i18n="@@REGISTER_MODAL.FACEBOOK_BUTTON"
    >Sign up with Facebook</span
  >
</button>
